export default function findIndexByFieldValue<T extends anyObject>(arr: Array<T>, key: keyof T | Array<keyof T>, newObject: T): number {
  if (Array.isArray(key)) {
    return arr.findIndex((_) => key.every((k) => _[k] === newObject[k]))
  }
  return arr.findIndex((_) => _[key] === newObject[key]);
}
